import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var origenParadas1: any;
declare var destinoParadas1: any;
declare var origenParadas2: any;
declare var destinoParadas2: any;

declare var i18nVS: any;
declare var GetArticlesURL: any; // URL dinamica para que Funcione tanto en Liferay como en VSC
declare var idCiudadLiferay: any; // El id de la ciudad en la que estamos
declare var portletNameServiceInformationLiferay: any; // Nombre del portlet en Liferay

declare var colorLineaClicada: any;
declare var nombreOrigen: any;
declare var nombreDestino: any;

declare var horariosJsonData: any;

@Component({
    selector: 'app-service-information-horarios',
    templateUrl: './horarios.component.html',
    styleUrls: ['../service-information.component.css']
})

export class HorariosComponent {
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = i18nVS;

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    @Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();

    jsonData; nombreLinea = '';
    idLinea = '';
    origen = '';
    destino = '';
    colorLinea = '#FF0000';

    horarioVacio = '-';

    inicioVerano = this.horarioVacio; finVerano = this.horarioVacio;
    inicioVeranoVuelta = this.horarioVacio; finVeranoVuelta = this.horarioVacio;
    frecuenciaVerano = this.horarioVacio;

    inicioVacacionesEscolares = this.horarioVacio; finVacacionesEscolares = this.horarioVacio;
    inicioVacacionesEscolaresVuelta = this.horarioVacio; finVacacionesEscolaresVuelta = this.horarioVacio;
    frecuenciaVacacionesEscolares = this.horarioVacio;

    inicioInvierno = this.horarioVacio; finInvierno = this.horarioVacio;
    inicioInviernoVuelta = this.horarioVacio; finInviernoVuelta = this.horarioVacio;
    frecuenciaInvierno = this.horarioVacio;

    inicioRamadan = this.horarioVacio; finRamadan = this.horarioVacio;
    inicioRamadanVuelta = this.horarioVacio; finRamadanVuelta = this.horarioVacio;
    frecuenciaRamadan = this.horarioVacio;

    inicioEpocaLV = this.horarioVacio; finEpocaLV = this.horarioVacio;
    inicioEpocaLVVuelta = this.horarioVacio; finEpocaLVVuelta = this.horarioVacio;
    frecuenciaEpocaLV = this.horarioVacio;

    inicioEpocaV = this.horarioVacio; finEpocaV = this.horarioVacio;
    inicioEpocaVVuelta = this.horarioVacio; finEpocaVVuelta = this.horarioVacio;
    frecuenciaEpocaV = this.horarioVacio;

    inicioEpocaS = this.horarioVacio; finEpocaS = this.horarioVacio;
    inicioEpocaSVuelta = this.horarioVacio; finEpocaSVuelta = this.horarioVacio;
    frecuenciaEpocaS = this.horarioVacio;

    inicioEpocaD = this.horarioVacio; finEpocaD = this.horarioVacio;
    inicioEpocaDVuelta = this.horarioVacio; finEpocaDVuelta = this.horarioVacio;
    frecuenciaEpocaD = this.horarioVacio;

    SinInformacion = '';

    origenParadas1 = '';
    destinoParadas1 = '';
    origenParadas2 = '';
    destinoParadas2 = '';

    // Clases
    mostrandoVeranoClass = 'disabled';
    mostrandoInviernoClass = 'disabled';
    mostrandoRamadanClass = 'disabled';
    mostrandoVacacionesEscolaresClass = 'disabled';

    portletName = ''; // Nombre del portlet

    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    public RecogerHorario() { // Recoge las lineas de un JSON
        this.leerDatos().subscribe(res => this.comprobandoJson(res), (err) => this.errorEnElJson(), () => this.finLLamada());
    }

    public comprobandoJson (res) {
        try {
            this.jsonData = res;
            horariosJsonData = this.jsonData;
        } catch (error) {
            this.errorEnElJson();
        }
    }

    leerDatos(): Observable<Response> {
        const body =  this.portletName + "cityId=" + idCiudadLiferay + "&" + this.portletName + "lineId=" + this.idLinea;
        const httpOptions = { 
            headers: new HttpHeaders({ 
                'Content-Type': 'application/x-www-form-urlencoded',
            })
        };
        return this.http.post(GetArticlesURL, body, httpOptions);
    }

    public finLLamada() {
        this.mostrarHorarios(1);
    }

    public filtrarHorarios(idLinea) {
        try {
            this.idLinea = idLinea;
            if (idLinea !== -1) {
                this.nombreLinea = 'Id linea: ' + idLinea;
            } else {
                this.nombreLinea = '';
            }
        } catch (error) {
            this.errorEnElJson();
        }
    }

    public errorEnElJson() {
        console.log('Error en los WS');
        this.onWebServiceError.emit(true);
    }

    public poblarOrigenDestino() {
        this.origen = nombreOrigen;
        this.destino = nombreDestino;
    }

    public poblarOrigenDestinoCorrutine() {
        this.poblarOrigenDestino();
        setTimeout(() => this.poblarOrigenDestinoCorrutine(), 250);
    }

    public PoblarVariables(idLinea) {
        this.origenParadas1 = origenParadas1;
        this.destinoParadas1 = destinoParadas1;
        this.origenParadas2 = origenParadas2;
        this.destinoParadas2 = destinoParadas2;

        this.colorLinea = colorLineaClicada;
        this.origen = nombreOrigen;
        this.destino = nombreDestino;
        this.idLinea = idLinea;
        this.RecogerHorario();

        this.poblarOrigenDestinoCorrutine();
    }

    public mostrarHorarios(epoca) {
        this.mostrandoVeranoClass = 'pointerMouse disabled';
        this.mostrandoInviernoClass = 'pointerMouse disabled';
        this.mostrandoRamadanClass = 'pointerMouse disabled';
        this.mostrandoVacacionesEscolaresClass = 'pointerMouse disabled';

        switch (epoca) {
            case 0: {
                this.mostrandoVeranoClass = '';
                this.inicioEpocaLV = this.jsonData.horarios[0].verano[0].lunesViernes[0].inicio;
                this.finEpocaLV = this.jsonData.horarios[0].verano[0].lunesViernes[1].fin;
                this.inicioEpocaLVVuelta = this.jsonData.horarios[0].verano[0].lunesViernes[2].inicio;
                this.finEpocaLVVuelta = this.jsonData.horarios[0].verano[0].lunesViernes[3].fin;
                this.frecuenciaEpocaLV = this.jsonData.horarios[0].verano[0].lunesViernes[4].frecuencia;

                this.inicioEpocaS = this.jsonData.horarios[0].verano[1].sabado[0].inicio;
                this.finEpocaS = this.jsonData.horarios[0].verano[1].sabado[1].fin;
                this.inicioEpocaSVuelta = this.jsonData.horarios[0].verano[1].sabado[2].inicio;
                this.finEpocaSVuelta = this.jsonData.horarios[0].verano[1].sabado[3].fin;
                this.frecuenciaEpocaS = this.jsonData.horarios[0].verano[1].sabado[4].frecuencia;

                this.inicioEpocaD = this.jsonData.horarios[0].verano[2].domingo[0].inicio;
                this.finEpocaD = this.jsonData.horarios[0].verano[2].domingo[1].fin;
                this.inicioEpocaDVuelta = this.jsonData.horarios[0].verano[2].domingo[2].inicio;
                this.finEpocaDVuelta = this.jsonData.horarios[0].verano[2].domingo[3].fin;
                this.frecuenciaEpocaD = this.jsonData.horarios[0].verano[2].domingo[4].frecuencia;
                break;
            }
            case 1: {
                this.mostrandoInviernoClass = '';
                this.inicioEpocaLV = this.jsonData.horarios[2].invierno[0].lunesViernes[0].inicio;
                this.finEpocaLV = this.jsonData.horarios[2].invierno[0].lunesViernes[1].fin;
                this.inicioEpocaLVVuelta = this.jsonData.horarios[2].invierno[0].lunesViernes[2].inicio;
                this.finEpocaLVVuelta = this.jsonData.horarios[2].invierno[0].lunesViernes[3].fin;
                this.frecuenciaEpocaLV = this.jsonData.horarios[2].invierno[0].lunesViernes[4].frecuencia;

                this.inicioEpocaS = this.jsonData.horarios[2].invierno[1].sabado[0].inicio;
                this.finEpocaS = this.jsonData.horarios[2].invierno[1].sabado[1].fin;
                this.inicioEpocaSVuelta = this.jsonData.horarios[2].invierno[1].sabado[2].inicio;
                this.finEpocaSVuelta = this.jsonData.horarios[2].invierno[1].sabado[3].fin;
                this.frecuenciaEpocaS = this.jsonData.horarios[2].invierno[1].sabado[4].frecuencia;

                this.inicioEpocaD = this.jsonData.horarios[2].invierno[2].domingo[0].inicio;
                this.finEpocaD = this.jsonData.horarios[2].invierno[2].domingo[1].fin;
                this.inicioEpocaDVuelta = this.jsonData.horarios[2].invierno[2].domingo[2].inicio;
                this.finEpocaDVuelta = this.jsonData.horarios[2].invierno[2].domingo[3].fin;
                this.frecuenciaEpocaD = this.jsonData.horarios[2].invierno[2].domingo[4].frecuencia;
                break;
            }
            case 2: {
                this.mostrandoVacacionesEscolaresClass = '';
                this.inicioEpocaLV = this.jsonData.horarios[1].vacacionesEscolares[0].lunesViernes[0].inicio;
                this.finEpocaLV = this.jsonData.horarios[1].vacacionesEscolares[0].lunesViernes[1].fin;
                this.inicioEpocaLVVuelta = this.jsonData.horarios[1].vacacionesEscolares[0].lunesViernes[2].inicio;
                this.finEpocaLVVuelta = this.jsonData.horarios[1].vacacionesEscolares[0].lunesViernes[3].fin;
                this.frecuenciaEpocaLV = this.jsonData.horarios[1].vacacionesEscolares[0].lunesViernes[4].frecuencia;

                this.inicioEpocaS = this.jsonData.horarios[1].vacacionesEscolares[1].sabado[0].inicio;
                this.finEpocaS = this.jsonData.horarios[1].vacacionesEscolares[1].sabado[1].fin;
                this.inicioEpocaSVuelta = this.jsonData.horarios[1].vacacionesEscolares[1].sabado[2].inicio;
                this.finEpocaSVuelta = this.jsonData.horarios[1].vacacionesEscolares[1].sabado[3].fin;
                this.frecuenciaEpocaS = this.jsonData.horarios[1].vacacionesEscolares[1].sabado[4].frecuencia;

                this.inicioEpocaD = this.jsonData.horarios[1].vacacionesEscolares[2].domingo[0].inicio;
                this.finEpocaD = this.jsonData.horarios[1].vacacionesEscolares[2].domingo[1].fin;
                this.inicioEpocaDVuelta = this.jsonData.horarios[1].vacacionesEscolares[2].domingo[2].inicio;
                this.finEpocaDVuelta = this.jsonData.horarios[1].vacacionesEscolares[2].domingo[3].fin;
                this.frecuenciaEpocaD = this.jsonData.horarios[1].vacacionesEscolares[2].domingo[4].frecuencia;
                break;
            }
            case 3: {
                this.mostrandoRamadanClass = '';
                this.inicioEpocaLV = this.jsonData.horarios[3].ramadan[0].lunesViernes[0].inicio;
                this.finEpocaLV = this.jsonData.horarios[3].ramadan[0].lunesViernes[1].fin;
                this.inicioEpocaLVVuelta = this.jsonData.horarios[3].ramadan[0].lunesViernes[2].inicio;
                this.finEpocaLVVuelta = this.jsonData.horarios[3].ramadan[0].lunesViernes[3].fin;
                this.frecuenciaEpocaLV = this.jsonData.horarios[3].ramadan[0].lunesViernes[4].frecuencia;

                this.inicioEpocaS = this.jsonData.horarios[3].ramadan[1].sabado[0].inicio;
                this.finEpocaS = this.jsonData.horarios[3].ramadan[1].sabado[1].fin;
                this.inicioEpocaSVuelta = this.jsonData.horarios[3].ramadan[1].sabado[2].inicio;
                this.finEpocaSVuelta = this.jsonData.horarios[3].ramadan[1].sabado[3].fin;
                this.frecuenciaEpocaS = this.jsonData.horarios[3].ramadan[1].sabado[4].frecuencia;

                this.inicioEpocaD = this.jsonData.horarios[3].ramadan[2].domingo[0].inicio;
                this.finEpocaD = this.jsonData.horarios[3].ramadan[2].domingo[1].fin;
                this.inicioEpocaDVuelta = this.jsonData.horarios[3].ramadan[2].domingo[2].inicio;
                this.finEpocaDVuelta = this.jsonData.horarios[3].ramadan[2].domingo[3].fin;
                this.frecuenciaEpocaD = this.jsonData.horarios[3].ramadan[2].domingo[4].frecuencia;
                break;
            }
            default: { }
        }
    }

    ngOnInit() {
        this.portletName = portletNameServiceInformationLiferay;
    }
    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(@Inject(HttpClient) private http) { }
}



// WEBPACK FOOTER //
// ./src/app/horarios/horarios.component.ts